import { StyledContainer } from './style';
import { TbMath } from 'react-icons/tb';
import commonStore from '../../../../store/common';
import toast from 'react-hot-toast';
import { DeleteConfirmToast } from '../DeleteConfirmToast';
import reportStore from '../../store';
import { observer } from 'mobx-react-lite';
import { idCreator } from '../../../Project/utils/idCreator';

interface CustomHeaderCellProps {
  title: string;
  onAddColumn?: () => void;
  onDeleteColumn?: () => void;
  hasDeleteBtn?: boolean;
  hasAddBtn?: boolean;
  hasDrillDown?: boolean;
  reportId?: string | number;
  fundId?: string | number;
  tableName?: string;
  columnName?: string;
  tableId?: string | number;
}

export const CustomHeaderCell = observer(
  ({
    title,
    onAddColumn,
    onDeleteColumn,
    hasDeleteBtn = false,
    hasAddBtn = true,
    hasDrillDown = false,
    reportId,
    fundId,
    tableName,
    columnName,
    tableId
  }: CustomHeaderCellProps) => {
    const { isConversionReportType } = reportStore;
    const onOpenDelete = () => {
      toast.custom(
        t => (
          <DeleteConfirmToast
            onDelete={() => {
              toast.remove();
              onDeleteColumn?.();
            }}
          />
        ),
        {
          duration: 1000000
        }
      );
    };

    return (
      <StyledContainer id={`custom-header-cell-${idCreator(title)}`}>
        <p id={`custom-header-cell-title-${idCreator(title)}`}>{title}</p>
        <div className="action-elements" id={`custom-header-cell-actions-${idCreator(title)}`}>
          {hasDeleteBtn && !commonStore.isViewer && (
            <button
              id={`custom-header-cell-delete-button-${idCreator(title)}`}
              onClick={onOpenDelete}
            >
              <DeleteIcon />
            </button>
          )}
          {hasAddBtn && !commonStore.isViewer && (
            <button id={`custom-header-cell-add-button-${idCreator(title)}`} onClick={onAddColumn}>
              <PlusIcon />
            </button>
          )}
          {hasDrillDown && !isConversionReportType && (
            <button
              id={`custom-header-cell-drill-down-button-${idCreator(title)}`}
              onClick={() =>
                commonStore.setDrillDown({
                  report_id: reportId,
                  fund_id: fundId,
                  table_name: tableName,
                  column_name: columnName,
                  table_id: tableId,
                  column_pretty_name: columnName
                })
              }
            >
              <TbMath color="#7888F5" />
            </button>
          )}
        </div>
      </StyledContainer>
    );
  }
);

const PlusIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.24996 2.66663C8.61815 2.66663 8.91663 2.9651 8.91663 3.33329V7.33329H12.9166C13.2848 7.33329 13.5833 7.63177 13.5833 7.99996C13.5833 8.36815 13.2848 8.66663 12.9166 8.66663H8.91663V12.6666C8.91663 13.0348 8.61815 13.3333 8.24996 13.3333C7.88177 13.3333 7.58329 13.0348 7.58329 12.6666V8.66663H3.58329C3.2151 8.66663 2.91663 8.36815 2.91663 7.99996C2.91663 7.63177 3.2151 7.33329 3.58329 7.33329H7.58329V3.33329C7.58329 2.9651 7.88177 2.66663 8.24996 2.66663Z"
      fill="#7888F5"
    />
  </svg>
);

const DeleteIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.97386 1.7239C6.22391 1.47385 6.56304 1.33337 6.91667 1.33337H9.58333C9.93696 1.33337 10.2761 1.47385 10.5261 1.7239C10.7762 1.97395 10.9167 2.31309 10.9167 2.66671V4.00004H12.9089C12.9136 3.99999 12.9183 3.99999 12.923 4.00004H13.5833C13.9515 4.00004 14.25 4.29852 14.25 4.66671C14.25 5.0349 13.9515 5.33337 13.5833 5.33337H13.5301L12.9164 12.6972C12.9085 13.2166 12.6988 13.713 12.3309 14.0809C11.9558 14.456 11.4471 14.6667 10.9167 14.6667H5.58333C5.0529 14.6667 4.54419 14.456 4.16912 14.0809C3.80125 13.713 3.59148 13.2166 3.58357 12.6972L2.96991 5.33337H2.91667C2.54848 5.33337 2.25 5.0349 2.25 4.66671C2.25 4.29852 2.54848 4.00004 2.91667 4.00004H3.57702C3.58174 3.99999 3.58644 3.99999 3.59113 4.00004H5.58333V2.66671C5.58333 2.31309 5.72381 1.97395 5.97386 1.7239ZM4.30787 5.33337L4.91436 12.6113C4.9159 12.6298 4.91667 12.6482 4.91667 12.6667C4.91667 12.8435 4.9869 13.0131 5.11193 13.1381C5.23695 13.2631 5.40652 13.3334 5.58333 13.3334H10.9167C11.0935 13.3334 11.263 13.2631 11.3881 13.1381C11.5131 13.0131 11.5833 12.8435 11.5833 12.6667C11.5833 12.6482 11.5841 12.6298 11.5856 12.6113L12.1921 5.33337H4.30787ZM9.58333 4.00004H6.91667V2.66671H9.58333V4.00004ZM6.91667 6.66671C7.28486 6.66671 7.58333 6.96518 7.58333 7.33337V11.3334C7.58333 11.7016 7.28486 12 6.91667 12C6.54848 12 6.25 11.7016 6.25 11.3334V7.33337C6.25 6.96518 6.54848 6.66671 6.91667 6.66671ZM9.58333 6.66671C9.95152 6.66671 10.25 6.96518 10.25 7.33337V11.3334C10.25 11.7016 9.95152 12 9.58333 12C9.21514 12 8.91667 11.7016 8.91667 11.3334V7.33337C8.91667 6.96518 9.21514 6.66671 9.58333 6.66671Z"
      fill="#CED4DA"
    />
  </svg>
);
